export default __webpack_public_path__ + "static/media/dao-logo.6a22dd6e.webp";